import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import QuestionBookComponent from './components/QuestionBookComponent'

const QuestionBook: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <QuestionBookComponent />
      <Footer />
    </>
  )
}

export default QuestionBook
